import axios from "axios";
//import LocalStorageService from "./services/storage/localstorageservice";
import router from "../router";
var parse = require("json-parse-safe");

// axios.defaults.baseURL = "http://localhost:3005";
// axios.defaults.baseURL = "https://rj123milhas-backend-v2-9d972ddbdaf2.herokuapp.com/";
const runtimeVariables = (window as any).variables || {};
const runtimeApiBaseUrl = runtimeVariables.API_BASE_URL || runtimeVariables.API;

axios.defaults.baseURL =
  (runtimeApiBaseUrl && !runtimeApiBaseUrl.includes("${") ? runtimeApiBaseUrl : "") ||
  process.env.VUE_APP_API_URL ||
  process.env.API_BASE_URL ||
  "https://api.rj123milhas.com.br";

// axios.defaults.headers.common['Origin'] = 'https://rj123milhas.com.br'

// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    const data = parse(<any>localStorage.getItem("token"));

    if (data.value) {
      config.headers["Authorization"] = "Bearer " + data.value.token;
    }
    // config.headers['Content-Type'] = 'application/json';

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const originalRequest = error.config;

    if (error.request.status == 0) {
      return Promise.reject(error);
    }

    if (
      error.response.status === 403
    ) {
      localStorage.clear();
      router.push("/home");

      if (!error.response.config.url.includes("/api/login")) {
        setTimeout(() => {
          window.location.reload();
        }, 2000)
      }


      return Promise.reject(error);
    }

    if (error.response.status === 419 && !originalRequest._retry) {
      originalRequest._retry = true;
      const token = parse(<any>localStorage.getItem("token"));

      return axios
        .get(
          `/sessions/${token.value.session}/access/new?access=${token.value.access}`
        )
        .then((res) => {
          if (res.status === 200) {
            localStorage.setItem("token", JSON.stringify(res.data.data));
            axios.defaults.headers.common["Authorization"] =
              "Bearer " + res.data.data.access;
          }
          return axios(originalRequest);
        })
        .catch((err) => {
          console.error(err);
          router.push("/login");
          return Promise.reject(error);
        });
    }

    //check error format
    if (error.response.data && "success" in error.response.data) {
      return Promise.reject(error.response.data);
    }

    return Promise.reject(error);
  }
);
